import { BodyText, TitleText } from 'styling/Typography'
import { AimLogoPale } from 'assets/icons/AimLogoPale'
import { NoAccessCard, NoAccessPageWrap } from './NoAccess.styled'

export const NoAccess = () => (
  <NoAccessPageWrap>
    <NoAccessCard>
      <AimLogoPale />
      <TitleText weight='bold'>No access to this application</TitleText>
      <BodyText grey>
        Your account does not have permission to use any part of this application. Contact your
        administrator if you believe this is a mistake.
      </BodyText>
    </NoAccessCard>
  </NoAccessPageWrap>
)
